export const safelyToJS = state =>
    typeof (state || {}).toJS === 'function' ? state.toJS() : state;
